<template>
  <div class="crm-side-panel-modal" @click="handleClose()">
    <div class="crm-side-panel-wrap" @click="handleStopHideDialog">
      <div class="title-bar" v-if="title">
        <div class="side-panel-title">
          <p style="-webkit-box-orient: block-axis;">{{title}}</p>
        </div>
        <div class="side-panel-tag" v-show="elTags && elTags.length > 0">
          <el-tag
            v-for="item in elTags"
            :key="item.label"
            :type="item.type"
            effect="dark">
            {{ item.label }}
          </el-tag>
        </div>
        <i class="el-icon-close icon-detail-close" @click="handleClose()"></i>
      </div>
      <div class="title-bar--no-head" v-else>
        <div class="side-panel-title">{{title}}</div>
        <i class="el-icon-close icon-detail-close" @click="handleClose()"></i>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    elTags: Array,
  },
  methods: {
    handleClose() {
      this.$emit('handleClose');
      this.isNext = true;
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    handleClick() {
      this.$emit('test');
    },
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.crm-side-panel-modal{
  z-index: 9;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .3);
  .crm-side-panel-wrap {
    background-color: #f4f4f4;
    display: flex;
    flex-direction: column;
    z-index: 9;
    float: right;
    width: 90%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 2px 10px rgba(0,0,0,.3);
    .title-bar {
      position: absolute;
      height: 40px;
      width: 90%;
      background-color: rgba(255, 255, 255, 0.3);
      .side-panel-tag {
        margin-left: 200px;
        padding: 6px;
      }
      .side-panel-title {
        position: fixed;
        top: 40px;
        margin-left: 30px;
        box-sizing: border-box;
        width: 160px;
        height: 150px;
        padding: 50px 12px 34px;
        background-image: url('../../images/home/paneltitle.png');
        font-weight: @fw--bold;
        font-size: @font-size--16;
        color: @color--white;
        text-align: center;
        p {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          -webkit-box-orient: block-axis;
          overflow: hidden;
        }
      }
      .icon-detail-close{
        position: absolute;
        right: 20px;
        padding: 0;
        background: 0 0;
        border: none;
        line-height: 40px;
        outline: 0;
        cursor: pointer;
        font-size: 16px;
      }
    }
    .title-bar--no-head {
      position: absolute;
      height: 40px;
      width: 90%;
      .icon-detail-close{
        position: absolute;
        right: 20px;
        padding: 0;
        background: 0 0;
        border: none;
        line-height: 40px;
        outline: 0;
        color: @color--white;
        cursor: pointer;
        font-size: 16px;
      }
    }
  }
  .el-tag {
    height: 28px;
    line-height: 26px;
  }
}


</style>
